import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import cn from './style.module.scss';
import './style.scss';
import { HighlightHTML, ContentDropdown } from "@learningblocks/storybook-components";

export function FullWidthAnimation(props) {

  const player = useRef();
  const playerWrapper = useRef();
  const playerVisible = useOnScreen(playerWrapper);

  const [playerRun, setPlayerRun] = useState(false);
  const [stopped, setStopped] = useState(true);

  const stop = () => {
    setStopped(true);
  };
  const play = () => {
    setStopped(false);
  }

  useEffect(() => {
    if (playerVisible && player.current && !playerRun) {
      player.current.play();
      setPlayerRun(true)
    }
  }, [playerVisible, playerRun]);

  const className = `${cn.image} ${props.className} notebook-image-component`;

  const animation = (
    <div
    ref={playerWrapper}
    aria-label={props.altText}
    className="stopped"
    style={{
      position: "relative"
    }}>
      <div style={{
        display: (!stopped)?"none":null,
        background: "rgba(0, 0, 0, 0.5)",
        position: "absolute",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        zIndex: 9,
        cursor: "pointer"
      }}
      onClick={()=>{
        player.current.play();
      }}
      >
        <button class='play'></button>
      </div>
      <Player
        ref={player}
        //alt='content-item'
        //className={props.className}
        onEvent={(event) => {
          if (event === "play")
            play();
          if (event === "stop")
            stop();
          if (event === "complete")
            stop();
        }}
        loop={false}
        autoplay={false}
        controls
        src={props.animation}
      >
        <Controls visible={true} buttons={["play", "stop"]} />
      </Player>
    </div>
  );
  if (props.caption) {
    return (
      <figure className={className}>
        {animation}
        <figcaption>
          <HighlightHTML
            key={props.id}
            content={props.caption}
            getContentData={props.getGlossaryItem}
            openGlossary={props.onOpenGlossary}
          />
        </figcaption>
        {props.contentDropdown !== undefined ?
          <ContentDropdown
            contentDetails={props.contentDropdown}
          />
        : null}
      </figure>
    );
  } else {
    return animation;
  }
}

FullWidthAnimation.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  animation: PropTypes.string.isRequired,
  className: PropTypes.string,
  caption: PropTypes.string,
  getGlossaryItem: PropTypes.function,
  onOpenGlossary: PropTypes.function
};


export function useOnScreen(ref) {
  const [isIntersecting, setIntersecting] = useState(false);

  const observer = new IntersectionObserver(
    ([entry]) => setIntersecting(entry.isIntersecting),
    { rootMargin: "-50% 0%" }
  );

  useEffect(() => {
    if (ref.current) {
      observer.observe(ref.current);
      // Remove the observer as soon as the component is unmounted
      return () => {
        observer.disconnect();
      };
    }
  }, [ref.current]);

  return isIntersecting;
}
